import { LitElement, html } from "lit-element";

class ToneTransport extends LitElement {
  static get properties() {
    return {
      minTempo: { type: Number },
      maxTempo: { type: Number },
      rampSpeed: { type: Number },
    };
  }

  constructor() {
    super();

    this.minTempo = 100;
    this.maxTempo = 200;
    this.rampSpeed = 4;

    const startContainer = document.querySelector("#start-container");
    const startButton = document.querySelector("#start");

    function createRamp({ tempoHigh, tempoLow, delay }) {
      let start = true;
      return function inner() {
        const tempo = start ? tempoHigh : tempoLow;
        Tone.Transport.bpm.rampTo(tempo, delay);
        start = !start;
      };
    }

    // start button click handler
    startButton.addEventListener("click", async () => {
      const ramp = createRamp({
        tempoHigh: this.maxTempo,
        tempoLow: this.minTempo,
        delay: this.rampSpeed,
      });
      Tone.Transport.bpm.value = this.minTempo;
      await Tone.start();
      await Tone.Transport.start();
      setInterval(
        (function doRamp() {
          ramp();
          return doRamp;
        })(),
        this.rampSpeed * 1000
      );
      startContainer.removeChild(startButton);
    });
  }

  render() {
    return html` <slot></slot> `;
  }
}
customElements.define("tone-transport", ToneTransport);
